import type { IFieldConfig } from './Field.types'
import { genDataField, genField } from './genField'

export { default } from './Field'
export { genDataField, genField }
export const getParams = <D>(config: IFieldConfig<D>, data: D) =>
  typeof config.params === 'function' ? config.params(data, config) : config.params || {}
